export default __webpack_public_path__ + "static/media/cards-stack-offset-light-icon.623c1bdd.svg";